// utils/date.js
// Format a message timestamp for display: time only if today, otherwise date + time (es-MX).
export function formatMessageDate(value) {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''

  const now = new Date()
  const time = d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })

  if (d.toDateString() === now.toDateString()) return time

  const sameYear = d.getFullYear() === now.getFullYear()
  const date = d.toLocaleDateString(
    'es-MX',
    sameYear ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short', year: 'numeric' }
  )
  return `${date}, ${time}`
}
